// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

import { createIllustration } from '@atlassian/jira-illustration/src/ui/index.tsx';
import type { IllustrationFn, AsImgProps } from '@atlassian/jira-illustration/src/ui/types.tsx';
import srcDark from '../../assets/empty-cannot-view-item-darkmode.svg';
import srcLight from '../../assets/empty-cannot-view-item.svg';

const Illustration: IllustrationFn<AsImgProps> = createIllustration({
	srcLight,
	srcDark,
	autoDark: false,
});

export default Illustration;
